//NEW: UI_REVAMP
import { Flex, Spinner, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useBettingScreen } from '../../hooks/useStore';
import ImgComp from '../../utils/ImgComp';
import SiteOptionContent from './SiteOptionContent';

const SiteOptionTab = ({
	activeSiteType,
	setActiveSiteType,
	getDraw,
	time,
	setTime,
	timeBtnId,
	setTimeBtnId,
	setTimeName,
	serverTime,
	getGame,
	activeBetType,
	setActiveBetType,
	handleLucky,
	showBetList,
	setShowBetList,
}) => {
	const betting = useBettingScreen((state) => state.betting);
	const [is2DList, set2DList] = useState([]);
	const [is3DList, set3DList] = useState([]);

	useEffect(() => {
		let filter3D = betting.filter((item) => ['SWER3', 'MANDAUE', 'RG7'].includes(item.gameType));
		let filter2D = betting.filter((item) => item.gameType === 'EZ2');

		set3DList(filter3D);
		set2DList(filter2D);
	}, [betting]);

	if (getGame.isLoading)
		return (
			<Flex
				justifyContent='center'
				h='140px'
				alignItems='center'
				bg='#F5F5F8 '
				mx='8px'
				border='1px solid white'
				borderRadius={16}
			>
				<Spinner size='xl' thickness='3px' />
			</Flex>
		);

	return (
		<Tabs
			isFitted
			variant='enclosed'
			border='1px solid white'
			borderRadius={16}
			overflow='hidden'
			index={activeSiteType}
			onChange={setActiveSiteType}
			mx='8px'
			bgGradient='linear-gradient(180deg, #E8ECF3 0%, #D3E2FD 34.97%)'
		>
			<TabList
				bgGradient='linear-gradient(180deg, #E8ECF3 0%, #ECF3FF 34.97%)'
				border='none'
				boxShadow='0 -4px 12px 0 #D3E2FD inset'
				maxH={10}
			>
				{getGame.data?.map((item, index) => {
					const totalTabs = getGame.data.length;
					const isFirst = index === 0;
					const isLast = index === totalTabs - 1;
					const onlyOne = totalTabs === 1;

					let selectedStyle = {};

					if (onlyOne) {
						selectedStyle = { bg: '#F5F5F8 ' };
					} else if (isFirst) {
						selectedStyle = {
							bgImage: `url('/assets/img/first-tab.png')`,
							bgSize: '100% 41px',
							bgRepeat: 'no-repeat',
							bgPosition: 'center',
						};
					} else if (isLast) {
						selectedStyle = {
							bgImage: `url('/assets/img/last-tab.png')`,
							bgSize: '100% 41px',
							bgRepeat: 'no-repeat',
							bgPosition: 'center',
						};
					} else {
						selectedStyle = {
							bgImage: `url('/assets/img/firstorlast-tab.png')`,
							bgSize: '100% 41px',
							bgRepeat: 'no-repeat',
							bgPosition: 'center',
						};
					}

					return (
						<Tab
							key={item.id}
							position='relative'
							display='flex'
							justifyContent='center'
							alignItems='center'
							gap={2}
							bgSize='cover'
							borderBottom='1px solid #F2F3F7'
							bgRepeat='no-repeat'
							bgPosition='center'
							_selected={selectedStyle}
							h={10}
							mx='-4px'
							border='none'
						>
							<ImgComp svgName={item.name.toLowerCase()} width={8} height='auto' />
							<Text as='span' textTransform='uppercase' fontSize='14px' fontWeight={600}>
								{item.name}
							</Text>
						</Tab>
					);
				})}
			</TabList>
			<TabPanels
				borderTop='1px solid white'
				bgGradient='linear-gradient(180deg, #F5F5F8 0%, #EFF5FF 100%)'
				borderTopLeftRadius={activeSiteType === 0 ? 0 : 16}
				borderTopRightRadius={activeSiteType === (getGame.data?.length || 1) - 1 ? 0 : 16}
			>
				{getGame.data?.map((item) => (
					<TabPanel key={item.id} p={0}>
						<SiteOptionContent
							gameType={item.name}
							list={['SWER3', 'MANDAUE', 'RG7'].includes(item.name) ? is3DList : is2DList}
							showBetList={showBetList}
							setShowBetList={setShowBetList}
							getDraw={getDraw}
							time={time}
							timeBtnId={timeBtnId}
							serverTime={serverTime}
							setTime={setTime}
							setTimeBtnId={setTimeBtnId}
							setTimeName={setTimeName}
							handleLucky={handleLucky}
							activeBetType={activeBetType}
							setActiveBetType={setActiveBetType}
						/>
					</TabPanel>
				))}
			</TabPanels>
		</Tabs>
	);
};

export default SiteOptionTab;
